import { Routes } from '@angular/router';
import { SharedPathSegments } from '@pgaoc/shared-lib';
import { AuthGuard } from './core/guards/auth.guard';
import { RefreshSessionGuard } from './core/guards/refresh-session.guard';
import { MembershipRoutes } from './core/routes/membership-routes';
import { UnauthenticatedRoutes } from './core/routes/unauthenticated-routes';
import { ReviewGolfIndustryHoursComponent } from './features/golf-industry-hours/review-golf-industry-hours/review-golf-industry-hours.component';

export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/layout/layout.routes').then(r => r.routes),
    canActivate: [AuthGuard],
  },
  {
    path: SharedPathSegments.auth(),
    loadChildren: () => import('./features/auth/auth.routes').then(r => r.routes),
    canActivate: [RefreshSessionGuard],
  },
  {
    path: MembershipRoutes.membershipApplication(),
    loadChildren: () => import('./features/membership-application/membership-application.routes').then(r => r.routes),
    canActivate: [RefreshSessionGuard],
  },
  {
    path: `${UnauthenticatedRoutes.reviewGolfIndustryHours()}/:golfIndustryHoursGuid`,
    component: ReviewGolfIndustryHoursComponent,
    canActivate: [RefreshSessionGuard],
  },
  {
    path: '**',
    redirectTo: 'auth',
  },
];
